<template>
  <div class="users">
    <span id="u-add-up">
      <ChatBlockAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"
      />
    </span>
    <va-card :title="$t('chatBlock.cards.title')">
      <template slot="actions">
        <va-button
          @click="open"
          href='#u-add-up'
          icon="fa fa-plus"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="block_chats"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('users.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href='#u-add-up'
              @click="update(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import ChatBlockAddUpdate from '../chat-block/ChatBlockAddUpdate.vue'

const perPage = 10
export default {
  name: 'ChatBlock',
  components: { ChatBlockAddUpdate },
  methods: {
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.updateData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.block_chats.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
  },
  data () {
    return {
      loggedUserId: this.$store.getters['authenticate/user'].id,
      block_chats: [],
      name: '',
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateData: null,
      userId: null,
    }
  },
  apollo: {
    block_chats: {
      query: gql`
      query MyQuery($page: Int, $perPage: Int) {
        block_chats: block_chat(limit: $perPage, offset: $page, order_by: {id: desc}) {
          id
          client_id
          expire_date
          message
          client {
            id
            fullName
          }
        }
      }
      `,
      variables () {
        return {
          perPage,
          page: 0,
        }
      },
    },
    pages: gql`
    query MyQuery {
      pages: block_chat_aggregate {
        aggregate {
          count
        }
      }
    }
    `,
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      const moment = this.$moment
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'client_id',
        title: this.$t('chatBlock.headings.clientId'),
      }, {
        name: 'client.fullName',
        title: this.$t('chatBlock.headings.name'),
        width: '35%',
      }, {
        name: 'message',
        title: this.$t('chatBlock.headings.message'),
      }, {
        name: 'expire_date',
        title: this.$t('chatBlock.headings.expiredDate'),
        width: '15%',
        callback (value) {
          return value ? moment(value).format('DD/MM/YYYY HH:mm') : ''
        },
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('block_chats')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.block_chats.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
